import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedModule } from 'app/shared.module';
import { NgApexchartsModule } from 'ng-apexcharts';

import { ColumnSelectorDialogComponent } from './column-selector-dialog.component';
import { DataBricksAiGenieQueryProcessChartComponent } from './databricks-genie-ai-query-process-chart.component';
import { DataBricksAiGenieQueryProcessTableComponent } from './databricks-genie-ai-query-process-table.component';
import { PinCardDialogComponent } from './pin-card-dialog.component';

@NgModule({
  declarations: [
    ColumnSelectorDialogComponent,
    DataBricksAiGenieQueryProcessChartComponent,
    DataBricksAiGenieQueryProcessTableComponent,
    PinCardDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule, // Import SharedModule first to get base functionality
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatSelectModule,
    MatTableModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatTooltipModule,
    NgApexchartsModule,
  ],
  exports: [ColumnSelectorDialogComponent, DataBricksAiGenieQueryProcessChartComponent, DataBricksAiGenieQueryProcessTableComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DataVisualizationSharedModule {}
